import React from 'react';
import { MoonLoader } from 'react-spinners';
interface LoaderProps {
  size?: 'sm' | 'md' | 'lg';
  title?: string;
  className?: string;
  isVisible?: boolean;
}

export const Loader: React.FC<LoaderProps> = ({
  size = "md",
  title = "Loading...",
  className = "",

}) => {
  const sizeMap = {
    sm: 20,
    md: 40,
    lg: 80
  };

  const loaderSize = sizeMap[size];
  return (
    <div className={`flex flex-col gap-4 items-center justify-center ${className}`}>
      <MoonLoader size={loaderSize} color="#465fff" />
      <header className="ml-2 text-lg font-100 text-text-primary">{title}</header>
    </div>
  );
};
